/**
 * [提醒设置]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */

import React, { useState, useEffect, useRef } from 'react';
import styles from './WarningModal.module.scss';
import { Modal, Form, Input, Button, Space, InputNumber, message } from 'antd';
import { regFenToYuan, regYuanToFen } from '@/util/money';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import * as apis from '@/apis/finance/platformAccount';


function WarningModal(props){

    const [data, setData] = useState({
        INCOME_ACCOUNT: {
            account: '0',
            accountCode: 'INCOME_ACCOUNT',
            alertAmount: 0,
            alertCode: 'INCOME_ACCOUNT_ALERT',
            contactPersonList: [{id: 1, name: '', tel: ''}],
        },
        FEE_ACCOUNT: {
            account: '0',
            accountCode: 'FEE_ACCOUNT',
            alertAmount: 0,
            alertCode: 'FEE_ACCOUNT_ALERT',
            contactPersonList: [{id: 2, name: '', tel: ''}],
        },
        SUBSTITUTION_ACCOUNT: {
            account: '0',
            accountCode: 'SUBSTITUTION_ACCOUNT',
            alertAmount: 0,
            alertCode: 'SUBSTITUTION_ACCOUNT_ALERT',
            contactPersonList: [{id: 3, name: '', tel: ''}],
        }
    });


    const idNum = useRef(3);

    useEffect(()=>{
        getPigWalletAlert();
    }, []);

    const getPigWalletAlert = ()=>{
        apis.getPigWalletAlert().then(res=>{
            initData(res.result);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const initData = (list)=>{
        let temp = {...data};
        list.forEach(v=>{
            let list = [...data[v.accountCode].contactPersonList];
            temp[v.accountCode] = {...v};
            temp[v.accountCode].alertAmount = regFenToYuan(v.alertAmount);
            if(v.contactPersonList.length){
                temp[v.accountCode].contactPersonList = v.contactPersonList.map(item=>{
                    idNum.current += 1;
                    item.id = idNum.current;
                    return item;
                });
            }else{
                temp[v.accountCode].contactPersonList = list;
            }
        });
        setData(temp);
    };

    const onClose=()=>{
        props.onClose();
    };

    const validate = ()=>{
        if(!data.INCOME_ACCOUNT.alertAmount){
            message.error('请设置收益账户余额提醒值！');
            return false;
        }
        if(!data.FEE_ACCOUNT.alertAmount){
            message.error('请设置手续费账户余额提醒值！');
            return false;
        }
        if(!data.SUBSTITUTION_ACCOUNT.alertAmount){
            message.error('请设置代付账户余额提醒值！');
            return false;
        }

        let status = true;
        let temp = [];
        temp = temp.concat(data.INCOME_ACCOUNT.contactPersonList).concat(data.FEE_ACCOUNT.contactPersonList).concat(data.SUBSTITUTION_ACCOUNT.contactPersonList);
        temp.forEach(v=>{
            if(!v.name || !v.tel){
                status = false;
                return false;
            }
        });
        if(!status){
            message.error('请完善提醒人信息！');
            return false;
        }
        return true;
    };

    const onSubmit = ()=>{
        if(!validate()){
            return false;
        }

        let list = Object.values(data);
        list = list.map(v=>{
            v.alertAmount = regYuanToFen(v.alertAmount)
            return v;
        });

        let formData = {list};
        apis.updatePigWalletAlert(formData).then(res=>{
            message.success('保存成功');
            onClose();
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onAdd = (groupKey)=>{
        idNum.current += 1;
        let temp = {...data[groupKey]};
        temp.contactPersonList.push({id: idNum.current, name: '', tel: ''});
        let tempData = {...data};
        tempData[groupKey] = temp;
        setData(tempData);
    }

    const onDel = (id, groupKey)=>{
        let temp = {...data[groupKey]};
        let list = temp.contactPersonList.filter(v=>v.id != id) || [];
        temp.contactPersonList = list;
        let tempData = {...data};
        tempData[groupKey] = temp;
        setData(tempData);
    }

    const onBalanceChange = (val, groupKey)=>{
        let temp = {...data[groupKey]};
        temp.alertAmount = val;
        let tempData = {...data};
        tempData[groupKey] = temp;
        setData(tempData);
    };

    const onNameChange = (e, groupKey, id)=>{
        let val = e.target.value || '';
        val = val.trim();
        let temp = {...data[groupKey]};
        let list = [];
        list = temp.contactPersonList.map(v=>{
            if(v.id == id){
                v.name = val;
            }
            return v;
        });
        temp.contactPersonList = list;
        let tempData = {...data};
        tempData[groupKey] = temp;
        setData(tempData);
    };

    const onTelChange = (e, groupKey, id)=>{
        let val = e.target.value || '';
        val = val.trim();
        let temp = {...data[groupKey]};;
        let list = [];
        list = temp.contactPersonList.map(v=>{
            if(v.id == id){
                v.tel = val;
            }
            return v;
        });
        temp.contactPersonList = list;
        let tempData = {...data};
        tempData[groupKey] = temp;
        setData(tempData);
    };

    const renderItems = (group)=>{
        return <>
            {data[group].contactPersonList.map((v, index)=>{
                return (
                    <div className={styles.item} key={v.id} >
                        <div className={styles.subItem}>
                            <span className={styles.label}>姓名：</span>
                            <Input className={styles.txt} value={v.name} onChange={e=>{onNameChange(e, group, v.id)}} />
                        </div>
                        <div className={styles.subItem}>
                            <span className={styles.label}>手机号：</span>
                            <Input className={styles.txt} value={v.tel} onChange={e=>{onTelChange(e, group, v.id)}}/>
                        </div>
                        {index ? <div className={styles.del} title="删除" onClick={()=>{onDel(v.id, group)}}><MinusCircleOutlined /></div> : <div className={styles.del}></div>}
                        {index >=4 ? null : <div className={styles.add} title="添加" onClick={()=>{onAdd(group)}}><PlusCircleOutlined /></div>}
                    </div>
                );
            })}
        </>
    };

    return <Modal visible={true} centered title="提醒设置" width="750px" bodyStyle={{padding: 0}} onOk={onSubmit} onCancel={onClose}>
        <div className={styles.container}>
            <div className={styles.tips}>当以下账户余额低于设置的金额时，每天早上9点及17点定时向以下人员发送余额不足短信，每个账户最多可提醒设置5人</div>
            <div className={styles.section}>
                <div className={styles.desc}>
                    <span>1、收益账户：{data.INCOME_ACCOUNT.account}</span>
                    <span>{`余额 <=`} <InputNumber min={0} precision={2} value={data.INCOME_ACCOUNT.alertAmount} onChange={(val)=>{onBalanceChange(val, 'INCOME_ACCOUNT')}} style={{width: '150px'}} /> 元</span>
                </div>
                {renderItems('INCOME_ACCOUNT')}
            </div>
            <div className={styles.section}>
                <div className={styles.desc}>
                    <span>2、手续费账户：{data.FEE_ACCOUNT.account}</span>
                    <span>{`余额 <=`} <InputNumber min={0} precision={2} value={data.FEE_ACCOUNT.alertAmount} onChange={(val)=>{onBalanceChange(val, 'FEE_ACCOUNT')}} style={{width: '150px'}} /> 元</span>
                </div>
                {renderItems('FEE_ACCOUNT')}
            </div>
            <div className={styles.section}>
                <div className={styles.desc}>
                    <span>3、代付账户：{data.SUBSTITUTION_ACCOUNT.account}</span>
                    <span>{`余额 <=`} <InputNumber min={0} precision={2} value={data.SUBSTITUTION_ACCOUNT.alertAmount} onChange={(val)=>{onBalanceChange(val, 'SUBSTITUTION_ACCOUNT')}} style={{width: '150px'}} /> 元</span>
                </div>
                {renderItems('SUBSTITUTION_ACCOUNT')}
            </div>
        </div>
    </Modal>
}

export default WarningModal;